import { FeedPageBangkok as registration } from '../templates';
import * as React from 'react';
import { hydrate } from 'react-dom';
import { StyleSheet } from 'aphrodite/no-important';
import { initCore } from 'mm-client-core';
import { createStoreFromPreloadedState } from '../store/storeFromPreloadedState';
import { ConsoleReporter } from '../errorReporting/consoleReporter';
import { markPerformance } from '../../performance';
import 'intersection-observer';
import { initClientApiForReadEvents, initClientApiForWriteEvents } from './clientAPI';
import { initStoreErrorReporter } from '../store/storeFromRequestParamsValidation';

var isEmptyObject = function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}; // eslint-disable-next-line


var _ref = // @ts-ignore TS2339
// eslint-disable-next-line
registration,
    component = _ref.component,
    clientAPIEvents = _ref.clientAPIEvents,
    getCoreParams = _ref.getCoreParams,
    rootReducer = _ref.rootReducer;
markPerformance('bundle-start'); // @ts-ignore TS2339

var state = window.__PRELOADED_STATE__;
var store = createStoreFromPreloadedState(state, rootReducer);
initClientApiForReadEvents(clientAPIEvents, store);
var coreParams = getCoreParams(state);

if (!isEmptyObject(coreParams)) {
  initCore(coreParams, new ConsoleReporter());
}

var errorProviderApp = new ConsoleReporter();
initStoreErrorReporter(errorProviderApp);

function initReactApp(target, appStore) {
  var Page = component; // @ts-ignore

  StyleSheet.rehydrate(window.__RENDERED_CLASS_NAMES__); // eslint-disable-next-line

  hydrate( /*#__PURE__*/React.createElement(Page, {
    store: appStore,
    errorProvider: errorProviderApp
  }), target, function () {
    return initClientApiForWriteEvents(clientAPIEvents, store);
  });
}

initReactApp(document.querySelector('#mm-root'), store);